import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言包
import zh from '../locales/zh.json';
import en from '../locales/en.json';
import zh_tw from '../locales/zh_tw.json';
import vi_vn from '../locales/vi_vn.json';
import ja_jp from '../locales/ja_jp.json';
import ko_kr from '../locales/ko_kr.json';

// 语言资源配置
const resources = {
  'en-US': { translation: en },
  'zh-CN': { translation: zh },
  'zh-TW': { translation: zh_tw },
  'vi-VN': { translation: vi_vn },
  'ja-JP': { translation: ja_jp },
  'ko-KR': { translation: ko_kr }
};

i18n
  .use(LanguageDetector)  
  .use(initReactI18next)  
  .init({
    resources,
    fallbackLng: 'zh-CN', 
    
    interpolation: {
      escapeValue: false  
    },
    
    // 语言检测配置
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;